import { useNavigate } from "react-router-dom";
import RGL, { Layout, WidthProvider } from "react-grid-layout";
import NavBar from "../components/navbar/NavBar";
import GridWindow from "../components/common/GridWindow";
import WindowIds from "../models/layout/windowIds";
import { useEffect, useRef, useState } from "react";
import ProjectInfo from "../models/projectInfo";
import ProjectCollectionInfo from "../models/projectCollectionInfo";
import projectService from "../services/projectService";
import localStorageService from "../services/localStorageService";

const ReactGridLayout = WidthProvider(RGL);

declare var Potree: any;

const HomeLidar: React.FC = () => {
  const [projectCollection, setProjectCollection] =
    useState<ProjectCollectionInfo>(new ProjectCollectionInfo());

  const [layout, setLayout] = useState<Layout[]>([]);

  const navigate = useNavigate();

  const ref = useRef<HTMLDivElement>(null);
  const viewerRef = useRef<any>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const defaultVisible: Layout[] = [];
    defaultVisible.push({ x: 0, y: 0, w: 12, h: 5, i: WindowIds.LidarId });
    setLayout(defaultVisible);

    const init = async () => {
      let projectCollection: ProjectCollectionInfo | undefined = undefined;
      let project: ProjectInfo | undefined = undefined;

      const { data: projectCollections } =
        await projectService.getProjectCollectionsInfos();

      const projectCode = "dfwairportcollection";

      let projectCodeFound = false;

      for (const projectCollection of projectCollections) {
        if (
          projectCollection.projects.find((p) => p.projectCode === projectCode)
        ) {
          projectCodeFound = true;
          break;
        }
      }

      if (!projectCodeFound) {
        navigate("/projects");
        return;
      }

      let idProjectCollection = localStorageService.getIdProjectCollection();

      if (!idProjectCollection) {
        navigate("/projects");
        return;
      }

      const prjCollection = projectCollections.find(
        (c) => c.idProjectCollection === idProjectCollection,
      );

      if (!prjCollection || prjCollection.projects.length === 0) {
        navigate("/projects");
        return;
      }

      projectCollection = prjCollection;

      let idProject = localStorageService.getIdProject();
      if (idProject) {
        project = prjCollection.projects.find((p) => p.idProject === idProject);
      }

      if (!project) {
        project = prjCollection.projects[0];
        localStorageService.setIdProject(project.idProject);
      }

      if (!projectCollection || !project) {
        return;
      }

      setProjectCollection(projectCollection);
      //setProject(project);
    };

    const viewer = new Potree.Viewer(ref.current);

    const initLidar = () => {
      // if (!window.Potree || !window.Potree.Viewer) {
      //   setTimeout(init, 50);
      //   return;
      // }

      //const viewer = new Potree.Viewer(ref.current);
      viewerRef.current = viewer;

      viewer.setEDLEnabled(true);
      viewer.setFOV(60);
      //viewer.setPointBudget(1_000_000);
      viewer.setPointBudget(2_000_000);

      viewer.setControls(viewer.earthControls);

      Potree.loadPointCloud(
        // "/pointclouds/sample/metadata.json",
        //"http://127.0.0.1:8080/metadata.json",
        "https://iccinformhosting.blob.core.windows.net/demo/lidar/metadata.json",
        "Sample",
        (e: any) => {
          // const pc = e.pointcloud;
          // viewer.scene.addPointCloud(pc);
          // viewer.fitToScreen();

          let scene = viewer.scene;
          let pointcloud = e.pointcloud;

          let material = pointcloud.material;
          material.size = 1;
          material.pointSizeType = Potree.PointSizeType.ADAPTIVE;
          material.shape = Potree.PointShape.SQUARE;
          material.activeAttributeName = "rgba";

          scene.addPointCloud(pointcloud);

          viewer.fitToScreen();

          setReady(true);
        },
      );
    };

    init();
    initLidar();

    return () => viewer.dispose?.();
  }, [navigate]);

  const onLayoutChanged = (layout: Layout[]) => {
    //console.log("layout:onLayoutChanged", layout);
  };

  const measure = () => {
    viewerRef.current?.measuringTool.startInsertion({
      showDistances: true,
    });
  };

  const removeMeasurements = () => {
    const viewer = viewerRef.current;

    viewer.scene.removeAllMeasurements();

    // viewerRef.current?.scene.addAnnotation([0, 0, 0], {
    //   title: "Annotation",
    // });
  };

  const toggleEDL = () => {
    const v = viewerRef.current;
    v.setEDLEnabled(!v.getEDLEnabled());
  };

  return (
    <>
      <NavBar
        underLogoContent={
          <>
            {/* hidden div to make the position abosolute from below to occupy/allocate space on y axis so when text is large to move items to the right */}
            <div
              style={{
                visibility: "hidden",
                marginTop: "-25px",
                marginLeft: "3px",
                fontSize: "10px",
                fontWeight: "bold",
                textWrap: "nowrap",
              }}
            >
              {projectCollection.collectionName}
            </div>
            <div
              style={{
                position: "absolute",
                bottom: "-3px",
                fontSize: "10px",
                fontWeight: "bold",
              }}
            >
              {projectCollection.collectionName}
            </div>
          </>
        }
      />
      <div id="content">
        <ReactGridLayout
          className="layout"
          layout={layout}
          cols={12}
          rowHeight={200}
          draggableHandle=".grid-window-title"
          onLayoutChange={onLayoutChanged}
          margin={[10, 10]}
          useCSSTransforms={false}
        >
          <div key={WindowIds.LidarId}>
            <GridWindow
              windowId={WindowIds.LidarId}
              title="Lidar"
              onClose={(windowId: string) => {}}
            >
              <>
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    left: 10,
                    zIndex: 10,
                    background: "#fff",
                    padding: 6,
                    borderRadius: 8,
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-sm btn-primary me-1"
                    onClick={measure}
                    disabled={!ready}
                  >
                    Measure
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary me-1"
                    onClick={removeMeasurements}
                    disabled={!ready}
                  >
                    Remove measurements
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={toggleEDL}
                    disabled={!ready}
                  >
                    Toggle EDL
                  </button>
                </div>

                <div ref={ref} style={{ width: "100%", height: "100%" }} />
              </>
            </GridWindow>
          </div>
        </ReactGridLayout>
      </div>
    </>
  );
};

export default HomeLidar;
